import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';

export const useSearchCreator = (keyword: string) => {
  return useQuery({
    queryKey: ['CREATOR_SEARCH', { keyword }],
    queryFn: () =>
      apiClientV2
        .get('/creators', {
          params: {
            'filter[]': `keyword:${keyword}`,
            pageSize: 5,
          },
        })
        .then((r) => r.data['hydra:member']),
    enabled: keyword.length > 2,
  });
};
